import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button, Flex, Box, Copy } from '@elparking/components'

import FilterButton from './FilterButton'

import {
    SCHUKO,
    MENNEKES,
    CHADEMO,
    CCS_COMBO,
    SAE_J1772,
    CEE_2P_E,
    CEE_3P_E,
    CEE_3P_N_E,
    SCHUKO_NAME,
    MENNEKES_NAME,
    CHADEMO_NAME,
    CCS_COMBO_NAME,
    SAE_J1772_NAME,
    CEE_2P_E_NAME,
    CEE_3P_E_NAME,
    CEE_3P_N_E_NAME,
} from 'commons/js/constants'
import PlugName from '../PlugName'
import PlugIcon from 'commons/js/components/PlugIcon'

const makeIsPlugTypeFilterEnabled = (plugType) => (filters) => filters && filters[plugType]
const makeUpdatePlugTypeFilter = (plugType) => (filters) => ({
    ...filters,
    [plugType.value]: !filters[plugType.value],
})

const chargingPointPlugTypes = [
    {
        text: SCHUKO_NAME,
        slug: SCHUKO,
        value: 'schuko',
        isEnabled: makeIsPlugTypeFilterEnabled('schuko'),
    },
    {
        text: MENNEKES_NAME,
        slug: MENNEKES,
        value: 'mennekes',
        isEnabled: makeIsPlugTypeFilterEnabled('mennekes'),
    },
    {
        text: CHADEMO_NAME,
        slug: CHADEMO,
        value: 'chademo',
        isEnabled: makeIsPlugTypeFilterEnabled('chademo'),
    },
    {
        text: CCS_COMBO_NAME,
        slug: CCS_COMBO,
        value: 'ccscombo',
        isEnabled: makeIsPlugTypeFilterEnabled('ccscombo'),
    },
    {
        text: SAE_J1772_NAME,
        slug: SAE_J1772,
        value: 'saej1772',
        isEnabled: makeIsPlugTypeFilterEnabled('saej1772'),
    },
    {
        text: CEE_2P_E_NAME,
        slug: CEE_2P_E,
        value: 'cee2pe',
        isEnabled: makeIsPlugTypeFilterEnabled('cee2pe'),
    },
    {
        text: CEE_3P_E_NAME,
        slug: CEE_3P_E,
        value: 'cee3pe',
        isEnabled: makeIsPlugTypeFilterEnabled('cee3pe'),
    },
    {
        text: CEE_3P_N_E_NAME,
        slug: CEE_3P_N_E,
        value: 'cee3pne',
        isEnabled: makeIsPlugTypeFilterEnabled('cee3pne'),
    },
]

function ChargingPointPlugTypeFilters ({
    filters: initialFilters,
    setFilters,
}) {
    const [filters, setDraftFilters] = useState(initialFilters)

    return (
        <Flex w='100%' flexWrap='wrap' px='1em'>
            <Box mb='2em'>
                <Copy padding='0' fontSize='xxLarge' fontWeight='medium' color='gray'>
                    <FormattedMessage defaultMessage='Conectores' />
                </Copy>
            </Box>
            <Flex w='100%' flexWrap='wrap' justifyContent='space-between' mb='1em'>
                {chargingPointPlugTypes.map((plugType, index) => (
                    <Box w='calc(50% - 0.5em)' mb='1em' key={index}>
                        <FilterButton
                          dataTest={`filter-button-${plugType.value}`}
                          width='100%'
                          padding='1em'
                          selected={plugType.isEnabled(filters)}
                          onClick={() => {
                              setDraftFilters(makeUpdatePlugTypeFilter(plugType))
                          }}
                        >
                            <PlugIcon plugSlug={plugType.slug} plugName={plugType.text} size='xxxLarge' color='inherit' />
                            <PlugName plugSlug={plugType.slug} color='inherit' fontSize='small' />
                        </FilterButton>
                    </Box>
                ))}
            </Flex>
            <Flex w='100%' justifyContent='space-between' alignItems='center'>
                <Box flex='1 1 auto'>
                    <Button.unstyled dataTest='cancel-filters-button' width='100%' color='gray60' onClick={() => { setFilters(initialFilters) }}>Cancelar</Button.unstyled>
                </Box>
                <Flex flex='1 0 auto'>
                    <Button width='100%' dataTest='apply-filters-button' height='auto' onClick={() => { setFilters(filters) }}>Aplicar filtros</Button>
                </Flex>
            </Flex>
        </Flex>
    )
}

ChargingPointPlugTypeFilters.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
}

export default ChargingPointPlugTypeFilters
